var _path, _g, _rect, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _circle3, _path7, _circle4, _circle5, _path8, _path9, _path10, _path11, _circle6, _circle7, _path12, _path13, _path14, _rect2, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path15, _path16, _path17, _path18, _path19, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEfVisual = function SvgEfVisual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 562 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.498 64.866a1 1 0 0 1 0-1.732l13.5-7.794a1 1 0 0 1 1.5.866v15.588a1 1 0 0 1-1.5.866l-13.5-7.794Z",
    stroke: "#000",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef_visual_svg__a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.933 187.578H273.8a4.222 4.222 0 0 0-4.222 4.222v3.378a4.222 4.222 0 0 0 4.222 4.222h10.133a4.222 4.222 0 0 0 4.222-4.222V191.8a4.222 4.222 0 0 0-4.222-4.222ZM283.933 214.6H273.8a4.222 4.222 0 0 0-4.222 4.222v3.378a4.222 4.222 0 0 0 4.222 4.222h10.133a4.222 4.222 0 0 0 4.222-4.222v-3.378a4.222 4.222 0 0 0-4.222-4.222ZM283.933 201.089H273.8a4.222 4.222 0 0 0-4.222 4.222v3.378a4.222 4.222 0 0 0 4.222 4.222h10.133a4.222 4.222 0 0 0 4.222-4.222v-3.378a4.222 4.222 0 0 0-4.222-4.222ZM304.2 187.578h-10.134a4.222 4.222 0 0 0-4.222 4.222v10.133a4.223 4.223 0 0 0 4.222 4.223H304.2a4.223 4.223 0 0 0 4.222-4.223V191.8a4.222 4.222 0 0 0-4.222-4.222ZM304.2 207.844h-10.134a4.223 4.223 0 0 0-4.222 4.223V222.2a4.222 4.222 0 0 0 4.222 4.222H304.2a4.222 4.222 0 0 0 4.222-4.222v-10.133a4.223 4.223 0 0 0-4.222-4.223Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 170,
    width: 74,
    height: 74,
    rx: 9,
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M289 169v-61M185 208v-41M186 207h65M154 166h32M327 207h81"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 484.499,
    cy: 215.5,
    r: 76.5,
    stroke: "#000",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.5,
    cy: 417.5,
    r: 76.5,
    stroke: "#000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m378.295 375.56-34.244 61.126a1 1 0 0 0 .397 1.368l44.497 24.034a1 1 0 0 0 1.354-.403l25.619-47.14c.131-.242.157-.529.071-.791l-7.521-22.799a.995.995 0 0 0-.476-.568l-28.352-15.22a1 1 0 0 0-1.345.393Z",
    stroke: "#000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "m376.75 399.848 26.032 14.942M364.158 420.28l26.032 14.941M368.355 413.469l26.033 14.942M372.553 406.659l26.032 14.941"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m330.541 388.481 2.917 70.004a1 1 0 0 0 1.056.957l50.49-2.885a1 1 0 0 0 .942-1.053l-2.922-53.572a1.002 1.002 0 0 0-.355-.711l-18.364-15.464a1 1 0 0 0-.703-.233l-32.122 1.917a1 1 0 0 0-.939 1.04Z",
    fill: "url(#ef_visual_svg__b)",
    stroke: "#000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "m341.968 409.969 30.001-.937M341.968 433.969l30.001-.937M341.968 425.969l30.001-.937M341.968 417.969l30.001-.937M93.892 149l3.393-3.477a1 1 0 0 0 .022-1.374l-18.77-20.473c-.589-.642-.134-1.676.736-1.676H102"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 164.5,
    r: 76.5,
    stroke: "#000",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 172h3.855c.93 0 1.725-.645 2.067-1.509 1.196-3.023 4.173-7.158 9.666-7.158 5.404 0 8.06 4.001 9.06 7.009.31.935 1.137 1.658 2.123 1.658h30.261c1.045 0 1.902-.811 2.189-1.815.853-2.988 3.379-6.852 9.132-6.852 5.856 0 8.681 4.004 9.724 7.012.323.931 1.148 1.656 2.134 1.647 4.031-.035 9.789-.196 9.789-.659 0-.666 0-8.666-2.706-10.666S98.029 156 94.647 154c-2.598-1.536-11.637-9.338-16.346-13.499a1.996 1.996 0 0 0-1.325-.501H43.404c-.54 0-1.058.218-1.434.606l-14.404 14.812a1.998 1.998 0 0 0-.566 1.394V170a2 2 0 0 0 2 2Z",
    fill: "url(#ef_visual_svg__c)",
    stroke: "#000",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 172.5,
    r: 6.5,
    stroke: "#000",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 172.5,
    r: 6.5,
    stroke: "#000",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 199.538h15.89a1 1 0 0 1 .726.312l19.562 20.58c.318.334.824.408 1.224.178l28.863-16.609a1 1 0 0 0-.106-1.787l-43.806-18.744a1 1 0 0 1-.356-1.582L69.2 176M30.153 141.955c.12-1.632 1.425-5.499 5.69-7.912 4.265-2.413 8.252-1.541 9.712-.803",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.588 140.412c.574-2.671 4.092-9.354 8.831-12.036 4.74-2.681 10.7-1.362 13.68-.702",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.022 138.869c.634-3.487 3.679-11.467 10.788-15.489 7.108-4.022 15.516-2.524 18.832-1.271M125.101 157.191c1.318.97 3.897 4.133 3.67 9.028-.227 4.896-3.088 7.807-4.49 8.65M129.37 153.301c1.956 1.908 5.741 8.443 5.489 13.882-.253 5.44-4.542 9.783-6.687 11.955",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.639 149.411c2.614 2.392 7.749 9.217 7.37 17.376-.378 8.159-6.122 14.479-8.947 16.619",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 54,
    r: 53,
    stroke: "#000",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 340,
    r: 53,
    stroke: "#000",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M290 245v95M371.999 287v53M248 339h41M289 288h82M466.981 216.667l-8.621-7.309a.997.997 0 0 1-.297-1.092l10.041-28.713a1 1 0 0 1 1.567-.453l11.394 9.064c.364.29.48.792.281 1.212l-12.815 26.957a1 1 0 0 1-1.55.334Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M448.372 233.967c-4.3-7.372-4.423-15.974-2.457-17.202 2.364-1.478 5.44-.681 8.474 1.228m-6.017 15.974c4.4 7.543 12.902 13.517 17.203 12.288 2.581-.738 2.728-5.459 1.503-10.445m-18.706-1.843c4.301 6.758 11.423 15.73 20.889 11.674 4.301-1.844 4.301-11.674-1.843-21.504-3.238-5.181-13.885-14.376-20.274-10.444-6.39 3.932-1.843 15.154 1.228 20.274Zm6.017-15.974c3.273 2.06 6.497 5.414 8.729 8.602 1.719 2.456 3.144 5.894 3.96 9.215m-12.689-17.817-10.034 18.61a1 1 0 0 0 .984 1.469l21.739-2.262m-20.549 0L441 240.111m78.582 19.734 15.061-31.281a.998.998 0 0 0-.301-1.234l-13.129-9.846a.999.999 0 0 0-1.494.352l-15.084 30.168a1 1 0 0 0 .254 1.215l13.152 10.96a1 1 0 0 0 1.541-.334Zm-17.813-14.709 15.045-30.092a1 1 0 0 0-.284-1.239l-14.28-10.985a1 1 0 0 0-1.536.415l-12.743 31.277c-.165.407-.046.874.293 1.152l11.977 9.799a1 1 0 0 0 1.528-.327Zm-36.745-69.355-9.983-7.882a1 1 0 0 0-1.574.486l-9.195 29.309c-.121.387.003.809.314 1.068l9.419 7.849a1 1 0 0 0 1.589-.452l9.759-29.277a1 1 0 0 0-.329-1.101Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M448.372 233.967c-4.3-7.372-4.423-15.974-2.457-17.202 2.364-1.478 5.44-.681 8.474 1.228m-6.017 15.974c4.4 7.543 12.902 13.517 17.203 12.288 2.581-.738 2.728-5.459 1.503-10.445m-18.706-1.843c4.301 6.758 11.423 15.73 20.889 11.674 4.301-1.844 4.301-11.674-1.843-21.504-3.238-5.181-13.885-14.376-20.274-10.444-6.39 3.932-1.843 15.154 1.228 20.274Zm6.017-15.974c3.273 2.06 6.497 5.414 8.729 8.602 1.719 2.456 3.144 5.894 3.96 9.215m-12.689-17.817-10.034 18.61a1 1 0 0 0 .984 1.469l21.739-2.262m-20.549 0L441 240.111m78.582 19.734 15.061-31.281a.998.998 0 0 0-.301-1.234l-13.129-9.846a.999.999 0 0 0-1.494.352l-15.084 30.168a1 1 0 0 0 .254 1.215l13.152 10.96a1 1 0 0 0 1.541-.334Zm-17.813-14.709 15.045-30.092a1 1 0 0 0-.284-1.239l-14.28-10.985a1 1 0 0 0-1.536.415l-12.743 31.277c-.165.407-.046.874.293 1.152l11.977 9.799a1 1 0 0 0 1.528-.327Zm-36.745-69.355-9.983-7.882a1 1 0 0 0-1.574.486l-9.195 29.309c-.121.387.003.809.314 1.068l9.419 7.849a1 1 0 0 0 1.589-.452l9.759-29.277a1 1 0 0 0-.329-1.101Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 264.998,
    y: 51,
    width: 40,
    height: 26,
    rx: 2,
    fill: "url(#ef_visual_svg__d)",
    stroke: "#000",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.998,
    cy: 42,
    r: 5,
    stroke: "#000",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.998,
    cy: 39,
    r: 8,
    stroke: "#000",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.998,
    cy: 40,
    r: 1,
    fill: "#000"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.998,
    cy: 39,
    r: 2,
    fill: "#000"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.998,
    cy: 35,
    r: 2,
    fill: "#000"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.998,
    cy: 43,
    r: 2,
    fill: "#000"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.998,
    cy: 39,
    r: 2,
    fill: "#000"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.998,
    cy: 42,
    r: 1,
    fill: "#000"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.998,
    cy: 42,
    r: 1,
    fill: "#000"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.998,
    cy: 44,
    r: 1,
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.536 186.004c1.643.182 5.206 1.577 8.839 6.144 3.648 4.586 4.398 9.883 4.321 12.421a.935.935 0 0 1-.491.782l-4.092 2.286-7.118-5.476a1 1 0 0 0-1.535.416l-5.22 12.811-19.846 11.088a.978.978 0 0 1-.731.096c-1.149-.306-3.77-1.179-6.359-4.217-2.799-3.284-2.492-6.829-1.927-8.405a.882.882 0 0 1 .277-.381l33.249-27.358a.858.858 0 0 1 .633-.207Z",
    fill: "url(#ef_visual_svg__e)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m509.375 192.148.782-.623-.782.623Zm-8.839-6.144.11-.993-.11.993Zm13.16 18.565 1 .03-1-.03Zm-.491.782.488.873-.488-.873Zm-4.092 2.286-.609.793.522.401.575-.321-.488-.873Zm-7.118-5.476.61-.792-.61.792Zm-1.535.416-.927-.378.927.378Zm-5.22 12.811.488.873.306-.171.132-.325-.926-.377Zm-19.846 11.088.487.873-.487-.873Zm-.731.096.257-.966-.257.966Zm-6.359-4.217.761-.649-.761.649Zm-1.927-8.405.941.338-.941-.338Zm.277-.381-.636-.772.636.772Zm33.249-27.358.635.772-.635-.772Zm10.254 5.314c-3.759-4.725-7.547-6.298-9.511-6.514l-.22 1.987c1.321.146 4.66 1.364 8.166 5.772l1.565-1.245Zm4.539 13.074c.082-2.711-.708-8.258-4.539-13.074l-1.565 1.245c3.466 4.357 4.177 9.404 4.105 11.768l1.999.061Zm-1.003 1.625a1.936 1.936 0 0 0 1.003-1.625l-1.999-.061c0-.023.008-.042.015-.052.005-.009.009-.01.005-.008l.976 1.746Zm-4.092 2.286 4.092-2.286-.976-1.746-4.091 2.286.975 1.746Zm.122-1.666-7.118-5.475-1.219 1.585 7.118 5.476 1.219-1.586Zm-7.118-5.475a2 2 0 0 0-3.072.83l1.853.755 1.219-1.585Zm-3.072.83-5.219 12.812 1.852.754 5.22-12.811-1.853-.755Zm-23.652 25.15 19.847-11.088-.976-1.746-19.846 11.088.975 1.746Zm-1.475.19c.51.135 1.038.055 1.475-.19l-.975-1.746-.002.001a.06.06 0 0 1 .016.002l-.514 1.933Zm-6.863-4.536c2.76 3.239 5.586 4.195 6.863 4.536l.514-1.933c-1.02-.272-3.437-1.063-5.855-3.9l-1.522 1.297Zm-2.108-9.39c-.66 1.844-.968 5.782 2.108 9.39l1.522-1.297c-2.522-2.959-2.215-6.11-1.747-7.418l-1.883-.675Zm.583-.816a1.884 1.884 0 0 0-.583.816l1.883.675c-.017.046-.038.061-.029.053l-1.271-1.544Zm33.25-27.358-33.25 27.358 1.271 1.544 33.249-27.358-1.27-1.544Zm1.378-.428a1.849 1.849 0 0 0-1.378.428l1.27 1.544c.006-.004.002.001-.016.007a.234.234 0 0 1-.096.008l.22-1.987Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "m211.98 308.169 6.862 9.922M207.319 310.764l11.999 10.743M203.632 313.45l14.545 10.909M200.854 317.052l15.406 9.702M200.264 321.414l11.471 6.53M200.731 325.171l8.309 3.294M197.34 329.875l6.031 5.845M192.096 330.363l11.237 9.462M189.08 332.536l13.636 10M187.261 335.263l13.637 10M187.322 338.949l10 9.091M188.303 343.57l4.546 5.454M180.05 350.343l7.943 3.006M177.244 351.011l11.808 7.869M174.534 352.536l13.637 10M173.712 354.429l11.818 11.818M174.724 359.101l6.363 10.001"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.674 371.119c.741.616 1.473 1.231 1.946 1.645l.004.009a1.046 1.046 0 0 0 .266.365 2.996 2.996 0 0 0 .428.291c.032.018.099.054.181.084.037.014.126.045.243.059h.001c.032.003.134.015.269-.005 1.329.434 4.257 1.271 7.568.946 4.061-.398 8.623-2.536 11.599-8.912 3.331-7.139 2.201-13.995 1.027-19.615a246.96 246.96 0 0 0-.288-1.359c-.487-2.285-.916-4.296-1.018-6.081-.119-2.1.233-3.675 1.335-4.868 1.138-1.234 3.119-2.039 5.764-2.537 2.615-.492 5.696-.653 8.859-.744.776-.022 1.558-.04 2.338-.058 2.367-.055 4.715-.109 6.815-.28 2.757-.224 5.312-.66 7.013-1.707.992-.61 1.63-1.587 2.023-2.696.392-1.105.564-2.405.587-3.777.046-2.746-.504-5.971-1.323-8.962-.818-2.991-1.927-5.825-3.045-7.787-.551-.967-1.15-1.805-1.777-2.328-.314-.262-.705-.504-1.162-.585a1.727 1.727 0 0 0-1.405.361c-.746.595-.903 1.514-.884 2.306.02.815.232 1.763.519 2.747.359 1.23.889 2.674 1.436 4.165.319.869.643 1.755.943 2.622.84 2.43 1.517 4.796 1.597 6.771.079 1.955-.426 3.285-1.684 4.04-1.51.906-3.937 1.481-6.922 1.847-2.953.363-6.301.507-9.569.638l-.41.017c-3.101.124-6.124.245-8.558.55-1.271.159-2.425.372-3.37.68-.914.298-1.79.732-2.32 1.438-.545.727-.697 1.794-.722 2.847-.026 1.11.09 2.453.282 3.926.259 1.988.669 4.307 1.098 6.725.204 1.154.413 2.331.61 3.505.619 3.672 1.141 7.353 1.178 10.466.019 1.555-.084 2.931-.341 4.074-.258 1.149-.656 1.994-1.176 2.557-1.731 1.876-4.908 2.999-8.564 3.571-3.605.564-7.457.559-10.301.356-1.43-.102-2.252 1.73-1.09 2.693Z",
    fill: "url(#ef_visual_svg__f)",
    stroke: "#000",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.168 349.444c-.555.834-.77 1.834-.792 2.871-.022 1.038.147 2.18.424 3.363.552 2.359 1.578 5.054 2.603 7.688l.247.635c.953 2.445 1.879 4.823 2.471 6.929.319 1.14.53 2.164.597 3.047.068.889-.016 1.565-.221 2.053-.196.466-.162.981.034 1.395.202.427.643.856 1.301.882.205.009.435.012.642-.003.102-.007.225-.02.347-.047.09-.02.325-.076.539-.251 1.722-1.409 1.741-3.707 1.294-5.897-.458-2.251-1.507-4.872-2.533-7.415l-.079-.195c-1.018-2.523-2.009-4.979-2.522-7.129-.539-2.262-.455-3.824.269-4.756.261-.335.754-.658 1.584-.919.82-.258 1.869-.424 3.114-.519 2.358-.18 5.241-.095 8.289-.006l.542.016c3.214.094 6.573.175 9.506-.089 2.886-.26 5.59-.869 7.322-2.335 1.923-1.627 2.026-4.293 1.554-6.993-.483-2.76-1.649-6.013-2.828-9.267l-.109-.301c-1.159-3.198-2.325-6.413-2.979-9.356-.681-3.065-.754-5.615.119-7.458 1.376-2.903 4.467-4.261 8.203-4.927 1.844-.329 3.772-.476 5.606-.58.428-.025.854-.047 1.274-.069 1.348-.07 2.629-.137 3.702-.263a1.488 1.488 0 0 0 1.311-1.482v-2.532c0-.856-.722-1.563-1.609-1.493-2.525.201-6.959.76-11.222 1.941-2.132.591-4.251 1.345-6.077 2.304-1.816.954-3.417 2.149-4.423 3.658-1.378 2.068-1.263 4.975-.676 7.953.537 2.725 1.533 5.787 2.518 8.814.112.344.224.686.334 1.028 1.101 3.399 2.122 6.708 2.51 9.588.392 2.911.097 5.11-1.113 6.522-1.324 1.544-3.545 2.355-6.423 2.666-2.859.309-6.169.105-9.46-.197-.807-.074-1.616-.155-2.416-.234-2.414-.24-4.745-.472-6.703-.498-1.309-.018-2.526.054-3.539.3-1.003.244-1.956.695-2.532 1.558Z",
    fill: "url(#ef_visual_svg__g)",
    stroke: "#000",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__b",
    x1: 327,
    y1: 386,
    x2: 383.5,
    y2: 458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6FF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__c",
    x1: 73,
    y1: 140,
    x2: 73,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6FF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__d",
    x1: 268.873,
    y1: 50,
    x2: 306.065,
    y2: 71.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6FF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__e",
    x1: 489.851,
    y1: 185.983,
    x2: 489.851,
    y2: 226.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6FF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__f",
    x1: 192.063,
    y1: 303.141,
    x2: 192.063,
    y2: 373.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFE6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef_visual_svg__g",
    x1: 196.241,
    y1: 304.05,
    x2: 196.241,
    y2: 379.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFE6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef_visual_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(251 169)",
    d: "M0 0h76v76H0z"
  })))));
};

export { SvgEfVisual as ReactComponent };
export default "/_next/static/images/ef_visual-79a710746626e344ff781dfb0c8a3a0f.svg";